import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import styles from "./checkoutaddress.module.css";
import { HeadingTitle, Loader } from "../../../../components/shared/index";
import { useUserAddressListQuery } from "../../../../queries/useUserAddress";
import { useOrderSummary } from "../../../../hooks/useOrderSummary";
import { FaPlus } from "react-icons/fa";

import { ErrorFallback, ErrorQueryBoundary } from "../../../../components";
import CheckoutOrderSummary from "../CheckoutPayment/CheckoutOrderSummary";
import toast from "react-hot-toast";
import UserAddressList from "./UserAddressList";
import AddMyAddress from "../../UserProfileOverview/MyAddress/AddMyAddress/AddMyAddress";

const CheckoutAddress = () => {
  const navigate = useNavigate();
  const [countryId] = useState(101);
  const [showForm, setShowForm] = useState(false);
  const [isProceeding, setIsProceeding] = useState(false);
  const location = useLocation();

const fromBuyNow = location.state?.fromBuyNow;
const [favoriteAddressId, setFavoriteAddressId] = useState(() => {
  return localStorage.getItem("favoriteAddressId") || null;
});
  const [selectedAddress, setSelectedAddress] = useState(() => {
    const saved = localStorage.getItem("checkoutAddress");
    return saved ? JSON.parse(saved) : null;
  });

  const { data: addressList = [], isPending: isPendingAddress } =
    useUserAddressListQuery();

  const savedShipping = JSON.parse(localStorage.getItem("shipping-rules"));

const cartItems = fromBuyNow
  ? [
      {
        id: location.state?.product_id,
        quantity: location.state?.quantity || 1,
        product: {
          id: location.state?.product_id,
          name: location.state?.productName,
          price: Number(location.state?.price),
          offer_price: Number(location.state?.offer_price),
          thumb_image: location.state?.thumb_image,
          vendor_id: location.state?.vendor_id,
        },
      },
    ]
  : JSON.parse(localStorage.getItem("selectedCheckoutItems")) || [];
const subtotal = cartItems.reduce((acc, item) => {
  const price = Number(
    item.product?.offer_price ||
      item.product?.price ||
      0
  );

  return acc + price * item.quantity;
}, 0);

const totalQty = cartItems.reduce(
  (acc, item) => acc + item.quantity,
  0
);

const shipping = Number(savedShipping?.cost || 0);

const tax = 0;

const total = subtotal + shipping;

const isCartPending = false;
  const orderSummary = {
    subtotal,
    shipping,
    tax,
    total,
    totalQty,
  };

  const existingAddress = {
    name: "",
    email: "",
    phone: "",
    country_id: String(countryId),
    state_id: "",
    city: "",
    zip: "",
    address: "",
    users_id: "",
  };

  const {
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: existingAddress,
  });

 const onSubmit = () => {
  if (!selectedAddress) {
    toast.error("Please select an address");
    return;
  }

  setIsProceeding(true);

  const newUserAddress = {
    id: selectedAddress.id,
    name: selectedAddress.name,
    email: selectedAddress.email,
    phone: selectedAddress.phone,
    country_id: selectedAddress.country_id,
    state_id: selectedAddress.state_id,
    city: selectedAddress.city,
    zip: selectedAddress.zip,
    address: selectedAddress.address,
  };

  localStorage.setItem(
    "checkoutAddress",
    JSON.stringify(newUserAddress)
  );

  setTimeout(() => {
    navigate("/checkout/payment", {
  state: {
    fromBuyNow: location.state?.fromBuyNow,
    ...location.state,
  },
});
  }, 500);
};

  const handleNextToPay = () => handleSubmit(onSubmit)();

  const handleSelectAddress = (address) => {
    setSelectedAddress(address);
    localStorage.setItem("checkoutAddress", JSON.stringify(address));
  };
const handleSetFavorite = (addressId) => {
  setFavoriteAddressId(addressId);
  localStorage.setItem("favoriteAddressId", addressId);
};
  return (
    <div className={styles.checkoutContainer}>
      <div className={styles.leftSection}>
        <HeadingTitle text="Delivery Address" style={styles.pageTitle} />

        <div
          className={styles.addAddressCard}
          onClick={() => setShowForm(true)}
        >
          <span className={styles.plus}>
            <FaPlus size={25} />
          </span>
          <p>Add New Address</p>
        </div>

        {showForm && (
          <div className={styles.formWrapper}>
            <AddMyAddress
              mode="add"
              onClose={() => setShowForm(false)}
              onSave={(newAddress) => {
                setSelectedAddress(newAddress);
                setShowForm(false);
              }}
            />
          </div>
        )}

        <ErrorQueryBoundary
          fallback={<Loader title="Loading user addresses.." />}
          errorFallback={<ErrorFallback />}
        >
          {isPendingAddress ? (
            <Loader title="Loading user addresses.." />
          ) : (
            <UserAddressList
              addressList={addressList}
              selectedAddress={selectedAddress}
              onSelect={handleSelectAddress} 
              favoriteAddressId={favoriteAddressId}
  onSetFavorite={handleSetFavorite}
            />
          )}
        </ErrorQueryBoundary>
      </div>

      <div className={styles.rightSection}>
        {isCartPending ? (
          <Loader title="Loading orders..." />
        ) : (
          <CheckoutOrderSummary
            cartItems={cartItems}
            orderSummary={orderSummary}
            isCartPending={isCartPending}
            handlePlaceOrder={handleNextToPay}
           isOrderPlacePending={isProceeding}
          />
        )}
      </div>
    </div>
  );
};

export default CheckoutAddress;